<template>
  <ul class="menu-nav">
    <!-- <router-link
        :to="{ name: 'top'}"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <i class="menu-icon flaticon2-architecture-and-city"></i>
          <span class="menu-text">ダッシュボード </span>
        </a>
      </li>
    </router-link> -->


    <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item menu-item-submenu"
        v-if="(currentUser.super_user == 1)" :class="{'menu-item-open': hasActiveChildren('business')}">
        <a href="#" class="menu-link menu-toggle">
            <i class="menu-icon fas fa-ad"></i>
            <span class="menu-text"> 補助事業管理 </span>
            <i class="menu-arrow"></i>
        </a>
        <div class="menu-submenu menu-submenu-classic menu-submenu-right">
            <ul class="menu-subnav">
                <router-link :to="{ name: 'business-ancillary'}" v-slot="{ href, navigate, isActive, isExactActive }">
                    <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item"
                        :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active' ]">
                        <a :href="href" class="menu-link" @click="navigate">
                            <i class="menu-icon fab fa-adversal"></i>
                            <span class="menu-text"> 事業登録 </span>
                        </a>
                    </li>
                </router-link>
                <router-link :to="{ name: 'business-category'}" v-slot="{ href, navigate, isActive, isExactActive }">
                    <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item"
                        :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active' ]">
                        <a :href="href" class="menu-link" @click="navigate">
                            <i class="menu-icon fas fa-ad"></i>
                            <span class="menu-text"> 費目カテゴリ管理 </span>
                        </a>
                    </li>
                </router-link>
                <router-link :to="{ name: 'business-cost'}" v-slot="{ href, navigate, isActive, isExactActive }">
                    <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item"
                        :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active' ]">
                        <a :href="href" class="menu-link" @click="navigate">
                            <i class="menu-icon fas fa-ad"></i>
                            <span class="menu-text"> 事業管理費目登録</span>
                        </a>
                    </li>
                </router-link>
                <router-link :to="{ name: 'business-cost-update'}" v-slot="{ href, navigate, isActive, isExactActive }">
                    <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item"
                        :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active' ]">
                        <a :href="href" class="menu-link" @click="navigate">
                            <i class="menu-icon fas fa-ad"></i>
                            <span class="menu-text"> 再委託管理費目登録 </span>
                        </a>
                    </li>
                </router-link>
                <!-- <router-link :to="{ name: 'business-cost-detail'}" v-slot="{ href, navigate, isActive, isExactActive }">
                        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item"
                            :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active' ]">
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-icon fas fa-ad"></i>
                                <span class="menu-text"> 予算登録 </span>
                            </a>
                        </li>
                        </router-link> -->
                        </ul>
                        </div>
                        </li>
                        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item menu-item-submenu"
                            :class="{'menu-item-open': hasActiveChildren('subcontractor') || hasActiveChildren('performance') || hasActiveChildren('budget-report') || hasActiveChildren('annual-voucher') || hasActiveChildren('detail-voucher-custom') || hasActiveChildren('weekly-voucher')}">
                            <a href="#" class="menu-link menu-toggle">
                                <i class="menu-icon fas fa-ad"></i>
                                <span class="menu-text"> 委託先管理 </span>
                                <i class="menu-arrow"></i>
                            </a>
                            <div class="menu-submenu menu-submenu-classic menu-submenu-right">
                                <ul class="menu-subnav">
                                    <router-link :to="{ name: 'subcontractor'}" v-slot="{ href, navigate, isActive, isExactActive }">
                                        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item"
                                            :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active' ]">
                                            <a :href="href" class="menu-link" @click="navigate">
                                                <i class="menu-icon fab fa-adversal"></i>
                                                <span class="menu-text"> 委託先一覧 </span>
                                            </a>
                                        </li>
                                    </router-link>
                                    <!-- <router-link :to="{ name: 'performance-action'}" v-slot="{ href, navigate, isActive, isExactActive }">
                                                <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item"
                                                    :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active' ]">
                                                    <a :href="href" class="menu-link" @click="navigate">
                                                        <i class="menu-icon fab fa-adversal"></i>
                                                        <span class="menu-text">委託先登録</span>
                                                    </a>
                                                </li>
                                            </router-link> -->
                                    <!-- <router-link :to="{ name: 'performance-report'}" v-slot="{ href, navigate, isActive, isExactActive }">
                                                <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item"
                             :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active' ]">
                                                    <a :href="href" class="menu-link" @click="navigate">
                                                        <i class="menu-icon fas fa-ad"></i>
                                                        <span class="menu-text"> 委託先承認 </span>
                                                    </a>
                                                </li>
                                            </router-link>
                                            <router-link :to="{ name: 'budget-report'}" v-slot="{ href, navigate, isActive, isExactActive }">
                                                <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item"
                             :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active' ]">
                                                    <a :href="href" class="menu-link" @click="navigate">
                                                        <i class="menu-icon fas fa-ad"></i>
                                                        <span class="menu-text"> 予算報告 </span>
                                                    </a>
                                                </li>
                                            </router-link> -->

                                </ul>
                            </div>
                        </li>













                        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item menu-item-submenu"
                            v-if="(currentUser.super_user == 1)"
                            :class="{'menu-item-open': hasActiveChildren('confirm') || hasActiveChildren('budget-pre')}">
                            <a href="#" class="menu-link menu-toggle">
                                <i class="menu-icon fas fa-ad"></i>
                                <span class="menu-text"> 予実管理 </span>
                                <i class="menu-arrow"></i>
                            </a>
                            <div class="menu-submenu menu-submenu-classic menu-submenu-right">
                                <ul class="menu-subnav">
                                    <!-- <router-link :to="{ name: 'confirm'}" v-slot="{ href, navigate, isActive, isExactActive }">
                                        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item"
                                            :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active' ]">
                                            <a :href="href" class="menu-link" @click="navigate">
                                                <i class="menu-icon fab fa-adversal"></i>
                                                <span class="menu-text"> 予実確認 </span>
                                            </a>
                                        </li>
                                    </router-link> -->
                                    <!-- <router-link :to="{ name: 'confirm-submit'}" v-slot="{ href, navigate, isActive, isExactActive }">
                                                <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item"
                                                    :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active' ]">
                                                    <a :href="href" class="menu-link" @click="navigate">
                                                        <i class="menu-icon fab fa-adversal"></i>
                                                        <span class="menu-text">予実登録</span>
                                                    </a>
                                                </li>
                                            </router-link> -->
                                    <router-link :to="{ name: 'budget-pre-actual-report'}" v-slot="{ href, navigate, isActive, isExactActive }">
                                        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item"
                                            :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active' ]">
                                            <a :href="href" class="menu-link" @click="navigate">
                                                <i class="menu-icon fab fa-adversal"></i>
                                                <span class="menu-text">予実レポート</span>
                                            </a>
                                        </li>
                                    </router-link>
                                    <!-- <router-link :to="{ name: 'budget-pre-comparision-report'}" v-slot="{ href, navigate, isActive, isExactActive }">
                                                <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item"
                                                    :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active' ]">
                                                    <a :href="href" class="menu-link" @click="navigate">
                                                        <i class="menu-icon fab fa-adversal"></i>
                                                        <span class="menu-text">予実対比レポート</span>
                                                    </a>
                                                </li>
                                            </router-link> -->


                                </ul>
                            </div>
                        </li>

                        <!--            <router-link-->
                        <!--          :to="{ name: 'top'}"-->
                        <!--          v-slot="{ href, navigate, isActive, isExactActive }"-->
                        <!--      >-->
                        <!--          <li-->
                        <!--              aria-haspopup="true"-->
                        <!--              data-menu-toggle="hover"-->
                        <!--              class="menu-item"-->
                        <!--              :class="[-->
                        <!--          isActive && 'menu-item-active',-->
                        <!--          isExactActive && 'menu-item-active'-->
                        <!--        ]"-->
                        <!--          >-->
                        <!--              <a :href="href" class="menu-link" @click="navigate">-->
                        <!--                  <i class="menu-icon flaticon2-architecture-and-city"></i>-->
                        <!--                  <span class="menu-text">証憑登録</span>-->
                        <!--              </a>-->
                        <!--          </li>-->
                        <!--      </router-link>-->
                        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item menu-item-submenu"
                            :class="{'menu-item-open': hasActiveChildren('voucher-register')}">
                            <!--        v-bind:class="{-->
                            <!--        'menu-item-open': hasActiveChildren('/list')-->
                            <!--      }"-->
                            <!--    >-->
                            <router-link v-if="(currentUser.super_user == 1)" class="menu-link menu-toggle" :to="{ name: 'voucher-register'}"
                                v-slot="{ href, navigate, isActive, isExactActive }">
                        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item"
                            :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active' ]">
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-icon fas fa-ad"></i>
                                <span class="menu-text"> その他証憑登録 </span>
                            </a>
                        </li>
                        </router-link>
                        <!-- <a href="#" class="menu-link menu-toggle">
                                                                <i class="menu-icon fas fa-ad"></i>
                                                                <span class="menu-text"> 証憑登録 </span>
                                                                <i class="menu-arrow"></i>
                                                            </a> -->
                        <!-- <div class="menu-submenu menu-submenu-classic menu-submenu-right">
                                        <ul class="menu-subnav">
                                            <router-link :to="{ name: 'voucher'}" v-slot="{ href, navigate, isActive, isExactActive }">
                                                <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item"
                                                    :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active' ]">
                                                    <a :href="href" class="menu-link" @click="navigate">
                                                        <i class="menu-icon fab fa-adversal"></i>
                                                        <span class="menu-text"> 年次証憑登録 </span>
                                                    </a>
                                                </li>
                                            </router-link>
                                            <router-link :to="{ name: 'voucher-search'}" v-slot="{ href, navigate, isActive, isExactActive }">
                                                <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item"
                                                    :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active' ]">
                                                    <a :href="href" class="menu-link" @click="navigate">
                                                        <i class="menu-icon fas fa-ad"></i>
                                                        <span class="menu-text"> 月次証憑登録 </span>
                                                    </a>
                                                </li>
                                            </router-link>
                                            <router-link :to="{ name: 'voucher-register'}" v-slot="{ href, navigate, isActive, isExactActive }">
                                                <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item"
                                                    :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active' ]">
                                                    <a :href="href" class="menu-link" @click="navigate">
                                                        <i class="menu-icon fas fa-ad"></i>
                                                        <span class="menu-text"> その他証憑登録 </span>
                                                    </a>
                                                </li>
                                            </router-link>
                                        </ul>
                                    </div> -->
                        </li>
                        <li v-if="(currentUser.super_user == 1)" aria-haspopup="true" data-menu-toggle="hover"
                            class="menu-item menu-item-submenu"
        :class="{'menu-item-open': hasActiveChildren('notification')}">
          <!--        v-bind:class="{-->
          <!--        'menu-item-open': hasActiveChildren('/list')-->
          <!--      }"-->
          <!--    >-->
          <a href="#" class="menu-link menu-toggle">
              <i class="menu-icon fas fa-ad"></i>
              <span class="menu-text">お知らせ管理</span>
              <i class="menu-arrow"></i>
          </a>
          <div class="menu-submenu menu-submenu-classic menu-submenu-right">
              <ul class="menu-subnav">
                  <router-link :to="{ name: 'notification-create'}" v-slot="{ href, navigate, isActive, isExactActive }">
                      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active' ]">
                          <a :href="href" class="menu-link" @click="navigate">
                              <i class="menu-icon fab fa-adversal"></i>
                              <span class="menu-text"> お知らせ登録</span>
                          </a>
                      </li>
                  </router-link>
                  <router-link :to="{ name: 'notification-edit'}" v-slot="{ href, navigate, isActive, isExactActive }">
                      <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item" :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active' ]">
                          <a :href="href" class="menu-link" @click="navigate">
                              <i class="menu-icon fas fa-ad"></i>
                              <span class="menu-text"> お知らせ更新</span>
                          </a>
                      </li>
                  </router-link>
              </ul>
          </div>
      </li>


    <router-link v-if="currentUser.super_user != 1" :to="{ name: 'budget-report', params: { answer_id: currentUser.answer_id } }" v-slot="{ href, navigate, isActive, isExactActive }">
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fas fa-ad"></i>
          <span class="menu-text">予算報告</span>
        </a>
      </li>
    </router-link>

    <router-link v-if="currentUser.super_user != 1" :to="{ name: 'performance-report', params: { answer_id: currentUser.answer_id } }" v-slot="{ href, navigate, isActive, isExactActive }">
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fas fa-ad"></i>
          <span class="menu-text">実績報告</span>
        </a>
      </li>
    </router-link>

    <router-link v-if="currentUser.super_user != 1" :to="{ name: 'annual-voucher', params: { answer_id: currentUser.answer_id } }" v-slot="{ href, navigate, isActive, isExactActive }">
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fas fa-ad"></i>
          <span class="menu-text">年次証憑登録</span>
        </a>
      </li>
    </router-link>

    <router-link v-if="currentUser.super_user != 1" :to="{ name: 'weekly-voucher', params: { answer_id: currentUser.answer_id } }" v-slot="{ href, navigate, isActive, isExactActive }">
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fas fa-ad"></i>
          <span class="menu-text">月次証憑登録</span>
        </a>
      </li>
    </router-link>

    <router-link v-if="currentUser.super_user != 1" :to="{ name: 'detail-voucher-custom', params: { id_answer: currentUser.answer_id } }" v-slot="{ href, navigate, isActive, isExactActive }">
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fas fa-ad"></i>
          <span class="menu-text">その他証憑登録</span>
        </a>
      </li>
    </router-link>

    <router-link v-if="currentUser.super_user != 1" :to="{ name: 'notification-list', params: { id_answer: currentUser.answer_id } }" v-slot="{ href, navigate, isActive, isExactActive }">
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
            <i class="menu-icon fas fa-ad"></i>
          <span class="menu-text">お知らせ</span>
        </a>
      </li>
    </router-link>



<!--


            <router-link
          :to="{ name: 'top'}"
          v-slot="{ href, navigate, isActive, isExactActive }"
      >
          <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
          >
              <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-icon flaticon2-architecture-and-city"></i>
                  <span class="menu-text">委託先検査・コメント登録</span>
              </a>
          </li>
      </router-link>
            <router-link
          :to="{ name: 'top'}"
          v-slot="{ href, navigate, isActive, isExactActive }"
      >
          <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
          >
              <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-icon flaticon2-architecture-and-city"></i>
                  <span class="menu-text">データ抽出</span>
              </a>
          </li>
      </router-link>
            <router-link
          :to="{ name: 'top'}"
          v-slot="{ href, navigate, isActive, isExactActive }"
      >
          <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
          >
              <a :href="href" class="menu-link" @click="navigate">
                  <i class="menu-icon flaticon2-architecture-and-city"></i>
                  <span class="menu-text">アカウント管理</span>
              </a>
          </li>
      </router-link> -->








  </ul>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTMenu",
  computed: {
        ...mapGetters(["currentUser"]),
    },
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    }
  }
};
</script>
